import React, { Fragment, PropsWithChildren } from 'react';
import { Box, List, Typography } from '@mui/material';
import { HeaderPrimaryButton, PageHeader } from 'components/layout/PageHeader';
import { ListSkeleton } from 'components/skeletons';
import { EmptyState } from 'components/empty.state';
import { BadgeOutlined, TouchAppOutlined } from '@mui/icons-material';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format } from "date-fns";
import { fr } from 'date-fns/locale';
import { roleList } from './constants';
import { useGetAgents } from 'core/agents/hooks';
import { ListCard } from 'components/list/list.card';

const menuSidebarWidth: string = "24rem";

const IndexPage = ({children}: PropsWithChildren) => {
    const {agentId} = useParams();
    const {data: agents, isLoading, isError} = useGetAgents({onError: (err) => toast.error("Une Erreur est survenue")});

    if (!isLoading && (isError || agents === undefined)) { return (<Typography>Une erreur est survenue</Typography>); }

    return (
        <Fragment>
            <PageHeader
                title='Agents'
                actions={<HeaderPrimaryButton component={Link} to='/dashboard/agents/new'>Ajouter un agent</HeaderPrimaryButton>}
            />
            <Box sx={{display: 'flex', gap: 0, justifyContent: 'space-between'}}>
                <List sx={{width: menuSidebarWidth, flexShrink: 0, p: '1rem', height: 'calc(100vh - 72px)', overflowY: 'scroll'}} disablePadding>
                    {isLoading && <ListSkeleton />}
                    {!isLoading && (agents || []).length === 0 && (
                        <EmptyState
                            icon={<BadgeOutlined />}
                            title='Aucun agent'
                            description="Invitez les membres de votre agence pour qu'ils accèdent au tableau de bord."
                            action={<HeaderPrimaryButton component={Link} to='/dashboard/agents/new' sx={{ boxShadow: 'none' }}>Ajouter un agent</HeaderPrimaryButton>}
                        />
                    )}
                    {(agents || []).map((agent: any) =>
                        <ListCard
                            key={agent.id}
                            component={Link}
                            to={`/dashboard/agents/${agent.id}`}
                            avatarSubstitute={`${agent.first_name[0].toUpperCase()}`}
                            selected={agentId === agent.id.toString()}
                            title={`${agent.first_name} ${agent.last_name}`}
                            subtitle={`Dernière connexion: ${agent.last_sign_in_at ? format(Date.parse(agent.last_sign_in_at), 'dd/MM/yy', {locale: fr}) : 'jamais'}`}
                            chips={[
                                {color: agent.role === 'admin' ? 'error' : agent.role === 'director' ? 'warning' : agent.role === 'manager' ? 'success' : 'info', label: roleList[agent.role] }
                            ]}
                        />
                    )}
                </List>
                <Box sx={{ flexGrow: 1, flexShrink: 1, minWidth: 0, pr: '1rem', py: '1rem', height: 'calc(100vh - 72px)', overflowY: 'scroll' }}>
                    {children ? (
                        <Box sx={{ borderRadius: '1rem', border: '1px solid #EDF0F3', boxShadow: 1, backgroundColor: 'background.paper', minWidth: 0, overflow: 'hidden' }}>
                            {children}
                        </Box>
                    ) : (
                        <EmptyState
                            size='md'
                            variant='dashed'
                            icon={<TouchAppOutlined />}
                            title="Sélectionnez un agent"
                            description="Cliquez sur un agent pour modifier son profil, son rôle ou ses agences."
                            sx={{ minHeight: 'calc(100vh - 72px - 2rem)' }}
                        />
                    )}
                </Box>
            </Box>
        </Fragment>
    );
};

export { IndexPage };